export default __webpack_public_path__ + "static/03.03-46fcd4a94c13590550464f225f7e8850.png";